module.exports = __webpack_public_path__ + "img/demon_gate_small.e0314ddb.png";